import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "Q3968",
    isNumber: true,
    isSum: true,
  },
];

export const VillageToDeal = {
  label: "鄉鎮 VS 處置",
  key: "VillageToDeal",
  path: "BoneMuscleCare/VillageToDeal",
  api: "TCS_V_UserInfoCaseV",
  render: (options) => <Diagram.BoneMuscleCare.VillageToDeal {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  dateRangeColumns: [
    // "Birthday",
    // "CaseCreateDate",
    { label: "Q3967", key: "Q3967" },
  ],
  levelColumns,
  columns: [],
};
